/* ZENVESSA theme scripts */
(function () {
  'use strict';
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var locale = document.documentElement.lang || 'it';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + (currency || ''); }
  }

  /* reveal on scroll */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  document.querySelectorAll('.reveal').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });

  /* lazy autoplay videos only when visible */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
    });
  }, { threshold: 0.15 }) : null;
  document.querySelectorAll('video[data-autoplay]').forEach(function (v) {
    v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
    if (vio) vio.observe(v); else v.play();
  });

  /* mobile nav */
  var nav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { if (nav) { nav.setAttribute('open', ''); document.body.style.overflow = 'hidden'; } }); });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { if (nav) { nav.removeAttribute('open'); document.body.style.overflow = ''; } }); });

  /* cart drawer */
  var drawer = document.querySelector('[data-cart-drawer]');
  var body = drawer && drawer.querySelector('[data-cart-body]');
  var foot = drawer && drawer.querySelector('[data-cart-foot]');
  var t = (drawer && drawer.dataset) || {};

  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); if (nav) nav.removeAttribute('open'); document.body.style.overflow = ''; } });
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); refreshCart().then(openDrawer); });
  });

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function kitOffer(cart) {
    var node = drawer && drawer.querySelector('[data-zv-kit-offers]');
    if (!node) return '';
    var offers;
    try { offers = JSON.parse(node.textContent); } catch (e) { return ''; }
    function handle(item) {
      try { return new URL(item.url, location.origin).pathname.split('/products/')[1]; } catch (e) { return ''; }
    }
    var handles = cart.items.map(handle);
    var offer = offers.find(function (o) {
      return o.available && handles.indexOf(o.handle) === -1 && o.members.some(function (h) { return handles.indexOf(h) !== -1; });
    });
    if (!offer) return '';
    var saving = offer.savings > 0 && offer.stable ? '<p class="zv-kit-upsell__saving">Risparmi ' + money(offer.savings, cart.currency) + ' con il kit</p><p class="zv-kit-upsell__comparison">Rispetto agli stessi tre prodotti acquistati singolarmente.</p>' : '';
    return '<aside class="zv-kit-upsell"><p class="zv-kit-upsell__eyebrow">Tre gesti, un solo kit</p>' +
      (offer.image ? '<img class="zv-kit-upsell__image" src="' + esc(offer.image) + '" alt="' + esc(offer.title) + '" width="96" height="96" loading="lazy">' : '') +
      '<div class="zv-kit-upsell__heading"><h3>' + esc(offer.title) + '</h3><span>' + money(offer.price, cart.currency) + '</span></div><p>' + offer.titles.map(esc).join(' · ') + '</p>' + saving +
      '<a class="zv-kit-upsell__link" href="' + esc(offer.url) + '">Scopri il kit →</a><p class="zv-kit-upsell__notice">I prodotti nel carrello non vengono sostituiti automaticamente.</p></aside>';
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-zv-gift]').forEach(function(gift) {
      var exists = cart.items.some(function(item){return item.variant_id === Number(gift.dataset.giftId);});
      var toggle = gift.querySelector('[data-gift-toggle]');
      var status = gift.querySelector('[data-gift-status]');
      if (toggle) { toggle.disabled = exists; if (exists) { toggle.checked = false; gift.querySelector('[data-gift-fields]').hidden = true; } }
      if (status) { status.textContent = exists ? gift.dataset.giftExisting : ''; status.hidden = !exists; }
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
    });
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><p class="h2">' + esc(t.empty) + '</p><p class="muted">' + esc(t.emptySub) + '</p><a class="btn btn--ghost" href="' + root + 'collections/all">' + esc(t.shop) + '</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="' + esc(it.product_title) + '" loading="lazy" width="84" height="105">' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="line-item__meta">' + esc(it.variant_title) + '</div>' : '';
      variant += Object.keys(it.properties || {}).filter(function(k){return k.charAt(0) !== '_' && it.properties[k];}).map(function(k){return '<div class="line-item__meta">' + esc(k) + ': ' + esc(it.properties[k]) + '</div>';}).join('');
      return '<div class="line-item"><a class="line-item__img" href="' + it.url + '">' + img + '</a><div><p class="line-item__title">' + esc(it.product_title) + '</p>' + variant +
        '<div class="qty" style="height:38px;margin-top:10px"><button type="button" data-qty-change="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="-">−</button><input value="' + it.quantity + '" readonly aria-label="qty"><button type="button" data-qty-change="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="+">+</button></div>' +
        '<button type="button" class="line-item__remove" data-qty-change="' + it.key + '" data-qty="0">' + esc(t.remove) + '</button></div><div class="price">' + money(it.final_line_price, cart.currency) + '</div></div>';
    }).join('') + kitOffer(cart);
    foot.querySelector('[data-cart-total]').textContent = money(cart.total_price, cart.currency);
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }

  if (body) {
    body.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-change]'); if (!b) return;
      b.disabled = true;
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.qtyChange, quantity: parseInt(b.dataset.qty, 10) }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(function () { b.disabled = false; });
    });
  }


  function zvGiftItem(gift) {
    var selection = gift.querySelector('[data-gift-message]');
    var props = { 'Dedica': selection.value, '_dedica_id': selection.selectedOptions[0].dataset.messageId };
    var from = gift.querySelector('[data-gift-from]').value.trim();
    var to = gift.querySelector('[data-gift-to]').value.trim();
    if (from) props.Da = from;
    if (to) props.Per = to;
    return {id: Number(gift.dataset.giftId), quantity: 1, properties: props};
  }
  document.addEventListener('change', function (event) {
    var gift = event.target.closest('[data-zv-gift]');
    if (!gift) return;
    if (event.target.matches('[data-gift-toggle]')) gift.querySelector('[data-gift-fields]').hidden = !event.target.checked;
    if (event.target.matches('[data-gift-message]')) gift.querySelector('[data-gift-copy]').textContent = event.target.value;
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gift-add]');
    if (!button || button.disabled) return;
    var gift = button.closest('[data-zv-gift]');
    var selection = gift.querySelector('[data-gift-message]');
    var error = gift.querySelector('[data-gift-error-message]');
    error.textContent = '';
    if (!selection.value) { error.textContent = gift.dataset.giftRequired; selection.focus(); return; }
    button.disabled = true;
    fetch(root + 'cart.js', {headers:{Accept:'application/json'}}).then(function (r) { if(!r.ok) throw new Error(); return r.json(); }).then(function (c) {
      if (c.items.some(function(line){return line.variant_id === Number(gift.dataset.giftId);})) { window.location.href = root + 'cart'; return; }
      return fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[zvGiftItem(gift)]})}).then(function(r){if(!r.ok) throw new Error(); window.location.href = root + 'cart';});
    }).catch(function(){error.textContent = gift.dataset.giftError;button.disabled=false;});
  });

  /* product forms (AJAX add to cart) */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawer) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var err = form.querySelector('[data-form-error]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      if (err) err.textContent = '';
      Promise.resolve().then(function () {
        var data = new FormData(form);
        var properties = {};
        data.forEach(function (value, key) { var m = key.match(/^properties\[(.+)\]$/); if (m) properties[m[1]] = value; });
        var items = [{ id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1, properties: properties }];
        if (data.get('selling_plan')) items[0].selling_plan = data.get('selling_plan');
        var gift = document.querySelector('[data-zv-gift][data-gift-form-id="' + form.getAttribute('id') + '"]');
        if (gift && gift.querySelector('[data-gift-toggle]:checked')) {
          var selection = gift.querySelector('[data-gift-message]');
          if (!selection.value) { selection.focus(); throw new Error(gift.dataset.giftRequired); }
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(gift.dataset.giftError); return r.json(); }).then(function (c) {
            if (!c.items.some(function (line) { return line.variant_id === Number(gift.dataset.giftId); })) items.push(zvGiftItem(gift));
            return items;
          });
        }
        return items;
      }).then(function (items) { return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({items: items}) }); })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return refreshCart(); }).then(openDrawer)
        .catch(function (j) { if (err) err.textContent = (j && (j.description || j.message)) || 'Error'; })
        .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
    });
  });

  /* quantity steppers on product page */
  document.querySelectorAll('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentElement.querySelector('input');
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
      input.value = v;
    });
  });

  /* variant picker */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var dataEl = picker.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = document.getElementById(picker.dataset.form);
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var btn = form && form.querySelector('[type="submit"]');
    var currency = picker.dataset.currency;
    picker.addEventListener('change', function () {
      var selected = Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
      if (!match) { if (btn) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; } return; }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price, currency);
      if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? btn.dataset.add : btn.dataset.soldout; }
      var url = new URL(window.location.href); url.searchParams.set('variant', match.id); history.replaceState(null, '', url.toString());
      if (match.featured_media_id) {
        var m = document.querySelector('[data-media-id="' + match.featured_media_id + '"]');
        var g = document.querySelector('[data-gallery]');
        if (m && g && g.firstElementChild !== m) g.insertBefore(m, g.firstElementChild);
      }
    });
  });

  /* sticky add to cart on mobile */
  var sticky = document.querySelector('[data-sticky-atc]');
  var mainBtn = document.querySelector('form[data-product-form] [type="submit"]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(mainBtn);
    sticky.querySelector('button').addEventListener('click', function () { mainBtn.click(); });
  }
})();
